<mat-list role="list" class="subtab-list">
  <mat-list-item role="listitem">
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Medication'}" (click)="subSelectedTab(1,'Medication')">
      <!-- <div class="activeTabContent1">Personality</div> -->
      <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Medication'}">Personality</div>
    </div>
  </mat-list-item>
  <mat-list-item role="listitem">
    <!-- <div class="tab1" (click)="subSelectedTab(2)">
        <div class="tabContent1">LifeStyle </div>
    </div> -->
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Diab'}" (click)="subSelectedTab(2,'Diab')">
      <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Diab'}">Lifestyle</div>
    </div>
  </mat-list-item>
  <mat-list-item role="listitem">
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Diet'}" (click)="subSelectedTab(3,'Diet')">
      <!-- <div class="tabContent1">Health & Medication</div> -->
      <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Diet'}">Health & Medication</div>
    </div>
  </mat-list-item>
  <mat-list-item role="listitem">
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Life'}" (click)="subSelectedTab(4,'Life')">
      <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Life'}">Dietary Habits </div>
    </div>
  </mat-list-item>
  <mat-list-item role="listitem">
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Fitness'}" (click)="subSelectedTab(5,'Fitness')">
      <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Fitness'}">Fitness </div>
    </div>
  </mat-list-item>
  <mat-list-item role="listitem">
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'NeoTranscript'}" (click)="subSelectedTab(6,'NeoTranscript')">
      <div class="tabContent1 tabContent1-multiline" [ngClass]="{'activeTabContent1': subTab === 'NeoTranscript'}">Renne conversations<br>Transcript</div>
    </div>
  </mat-list-item>
  <mat-list-item role="listitem">
    <div class="tab1" [ngClass]="{'activeTab1': subTab === 'NewOnboarding'}" (click)="subSelectedTab(7,'NewOnboarding')">
      <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'NewOnboarding'}">New Onboarding</div>
    </div>
  </mat-list-item>
</mat-list>

<div class="container-fluid" *ngIf="subTab=='Medication'">
  <div class="card">
    <div>
      <div class="row">
        <div class="col-lg-12">
          <div class="iq-card">


            <div class="iq-card-header d-flex justify-content-between">

              <div class="iq-header-title">
                <h4 class="card-title">Stress Test</h4>
                <h6 class="mt-2" style="font-size: 15px;">
                  For each question choose from the following alternatives:
                </h6>
              </div>
            </div>

            <div class="iq-card-body">
              <div class="form-group">

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let question of PersonalityStressQuestion">

                  <label for="city">{{question.question}}</label>

                  <div class="d-flex flex-row justify-content-around" style="width:30%">
                    <span class="d-flex align-items-end">Never</span>
                    <div class="d-flex flex-column options_Styles" *ngFor="let option of question.options" (click)="getOption(option,question.id)">
                      <p class="ml-2">{{option}}</p>
                      <!-- <p-radioButton class="radio_Styles" name="q2"  [value]="option" [checked]="selectedRadio._id==option"></p-radioButton> -->
                      <input type="radio" name="{{question.id}}" id="{{option}}" [checked]="!isSelectedAnswerBool ? option == question.answer : null || isSelected(question.id, option)" />
                    </div>

                    <span class="d-flex align-items-end">Very Often</span>

                  </div>
                  <div style="margin-top:16px;">
                    <input type="checkbox" [checked]="notAnsweredQuestionsStress.includes(question.id)" (click)="getOption('not answered', question.id)" style="transform: scale(1.2); margin-right: 8px;">
                    <span class="ml-1">Not Answered</span>
                  </div>

                </div>


                <div class="iq-header-title">

                  <h4 class="card-title mt-4">
                    Anxiety Test (GAD-7)
                  </h4>
                  <h6 class="mt-2" style="font-size: 15px;">
                    Over the last two weeks, how often have you been bothered by the following problems?
                    Not at all-0  Several days-1 More than half the days-2 Nearly every day-3
                  </h6>
                </div>
                <hr>
                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let question of PersonalityAnxietyQuestion">

                  <label for="city">{{question.question}}</label>

                  <div class="d-flex flex-row justify-content-around" style="width:30%">
                    <span class="d-flex align-items-end">Never</span>
                    <div class="d-flex flex-column options_Styles" *ngFor="let option of question.options" (click)="getOption(option,question.id)">
                      <p class="ml-2">{{option}}</p>

                      <!-- <p-radioButton class="radio_Styles" name="q2"  [value]="option" [checked]="selectedRadio._id==option"></p-radioButton> -->
                      <input type="radio" name="{{question.id}}" id="{{option}}" [checked]="!isSelectedAnswerBool ? option == question.answer : null || isSelected(question.id, option)" />
                    </div>

                    <span class="d-flex align-items-end">Very Often</span>

                  </div>
                  <div style="margin-top:16px;">
                    <input type="checkbox" [checked]="notAnsweredQuestionsAnxiety.includes(question.id)" (click)="getOption('not answered', question.id)" style="transform: scale(1.2); margin-right: 8px;">
                    <span class="ml-1">Not Answered</span>
                  </div>

                </div>


                <!-- ENAGRAM TEST ---------------------------------- -->
                <div class="iq-header-title">
                  <h4 class="card-title mt-4">
                    Enneagram Test
                  </h4>
                </div>
                <hr>

                <div class="form-group col-md-12 p-3 enneagram_stylings" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let question of PersonalityEnneagramQuestion">
                  <label for="city">{{question.question}}</label>

                  <div class="d-flex flex-row justify-flex-start" style="width:100%;height:200px">

                    <ol class="ol1">
                      <li class="li1" *ngFor="let option of question.options" [ngClass]="{ active: !isSelectedAnswerBool ? option == question.answer : null || isSelected(question.id, option)}">
                        <div class=""  
                             (click)="getOption(option,question.id)"
                             >
                          {{option}}
                        </div>
                      </li>

                    </ol>



                  </div>
                  <div>
                    <div style="margin-top:16px;">
                      <input type="checkbox" [checked]="notAnsweredQuestions.includes(question.id)" (click)="getOption('not answered', question.id)" style="transform: scale(1.2); margin-right: 8px;">
                      <span class="ml-1">Not Answered</span>
                    </div>
                  </div>

                </div>

                <div class="form-group col-md-6 ">
                  <div class="flex-auto mt-3">
                    <button type="button" (click)="saveQuestion()" class="btn btn-primary" [disabled]="savePersonalityBtn">Save</button>
                    <span *ngIf="savePersonalityBtn" style="margin-left:10px;">Saving answers. Please wait...</span>
                  </div>
                </div>
              </div>



            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</div>
<div class="container-fluid" *ngIf="subTab=='Diab'">
  <div class="card">
    <div>
      <div class="row">
        <div class="col-lg-12">
          <div class="iq-card">
            <div class="iq-card-body">
              <div class="form-group ">

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of LifestyleTabTextQuestions">
                  <label>{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <input type="text" id={{item.id}} (change)="getLifestyleAnswers(item.id,$event)" [value]="item.answer" class="form-control" placeholder="Enter your answer">
                  </div>
                </div>

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of LifestyleTabTimeQuestions">
                  <label>{{item.question}}</label>
                  <div class="d-flex flex-row justify-content-between" style="width:100%;">
                    <input type="time" class="form-control" (change)="getLifestyleAnswers(item.id,$event)" [value]="formatConversionHandler(item.answer)" placeholder="Enter your answer">
                  </div>
                  <div *ngIf="isLifestyleAnswered == true ? item.answer==null : ''" style="margin-top:10px;">
                    <input type="checkbox" (click)="getLifestyleAnswers(item.id,$event)" /> <span style="color:red;margin-left:10px;">Not Answered!</span>
                  </div>
                </div>

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of LifestyleTabDropDownQuestions">
                  <label>{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <select class="form-control" (change)="getLifestyleAnswers(item.id,$event)" [(ngModel)]="item.answer">
                      <option>select from option</option>
                      <option *ngFor="let option of item.options" [value]="option.val">{{option.key}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-6 ">
                  <div class="flex-auto mt-3">
                    <button (click)="saveLifestyleAnswers()" type="submit" class="btn btn-primary">Save</button> <span></span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="subTab=='Diet'">
  <div class="card">
    <div>
      <div class="row">
        <div class="col-lg-12">
          <div class="iq-card">
            <div class="iq-card-body">
              <div class="form-group">
                UPLOAD REPORT
                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;">
                  <label for="report">Upload</label>
                  <div class="d-flex flex-row justify-flex-start file_upload_styles" style="width:100%;">
                    <label for="file-upload-report" class="custom-file-upload">
                      <i class="fa fa-cloud-upload" style="margin-right: 10px;"></i>Upload Report
                    </label>
                    <input id="file-upload-report" type="file" (change)="onReportSelected($event)" [disabled]="isReportUploadDisabled" />
                    <!--<div class="label_file_upload">{{ selectedFileName }}</div>-->
                    <span style=" margin-top: 4px;">or</span>
                    <label style="margin-left: 20px;" for="file-upload-prescription" class="custom-file-upload">
                      <i class="fa fa-cloud-upload" style="margin-right: 10px;"></i>Upload Prescription
                    </label>
                    <input id="file-upload-prescription" type="file" (change)="onPrescriptionSelected($event)" [disabled]="isPrescriptionUploadDisabled" />
                    <!--<div class="label_file_upload">{{ selectedPrescriptionName }}</div>-->
                  </div>
                </div>
                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of HealthAndMedicationTextField">
                  <label for="city">{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <input type="text" id={{item.id}} (change)="getHealthAndMedicationAnswers(item.id,$event)" [value]="item.answer" class="form-control" placeholder="Enter your answer">
                  </div>
                </div>
                <form >
                  <div class="form-group col-md-12 p-3 healthAndMedication_stylings" style="background:#f4f4f4;border-radius: 15px;">
                    <label for="report">Do you have any family history of chronic diseases, such as heart disease or diabetes, or health conditions such as high blood pressure or high cholesterol?</label>
                   
                  
                  <details *ngFor="let question of HealthAndMedicationMultiSelect">
                    <summary> {{ question.question }}</summary>
                    <!--<ol><li  *ngFor="let item of getFormArrayByName(question.question.toLowerCase()).controls; let i = index" [ngClass]="{'selected': item.value}"
   onclick="toggleSelection(question.question.toLowerCase(), i)">
    <p >{{ question.options[i] }}</p>
  </li></ol>-->
                    <div class="d-flex flex-row justify-flex-start" style="width:100%;height:48px">
                      <ol class="ol">
                        <li class="li" *ngFor="let item of getFormArrayByName(question.question.toLowerCase()).controls; let i = index"
                            [ngClass]="{'selected': item.value}"
                            (click)="toggleSelection(question.question.toLowerCase(), i)">
                          {{ question.options[i] }}
                        </li>
                      </ol>
                    </div>
                  </details>
                     
                  </div>
                </form>



                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of HealthAndMedicationPlainText">
                  <label>{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <input type="text" id={{item.id}} (change)="getHealthAndMedicationAnswers(item.id,$event)" [value]="item.answer" class="form-control" placeholder="Enter your answer">
                  </div>
                </div>


                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of HealthAndMedicationMultiSelectWithKeys">
                  <label>{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <select class="form-control" (change)="getHealthAndMedicationAnswers(item.id,$event)" [(ngModel)]="item.answer">
                      <option disabled="true">select from option</option>
                      <option *ngFor="let option of item.options" [value]="option.val">{{option.key}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-12 p-3 " style="background:#f4f4f4;border-radius: 15px;">


                  <label>{{HealthAndMedicationListFields[0].question}}</label>
                  <select class="form-control" [(ngModel)]="selectedMedications">
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </select>
                  <div *ngIf="selectedMedications=='Yes'">
                    <div class="d-flex flex-row justify-content-between" style="width:100%;margin-bottom: 10px;margin-top:10px;" *ngFor="let meds of medications;let i = index;trackBy: trackByFn">
                      <input type="text" style="width: 90%;" [(ngModel)]="medications[i]" class="form-control" placeholder="Enter medicines" (ngModelChange)="logMedications()">
                      <button (click)="removeMedication(i)" class="btn btn-danger">Remove</button>
                    </div>
                    <button (click)="addMedications(HealthAndMedicationListFields[0].id)" class="btn btn-success">Add</button>
                  </div>
                </div>

                <div class="form-group col-md-12 p-3 " style="background:#f4f4f4;border-radius: 15px;">

                  <label>{{HealthAndMedicationListFields[1].question}}</label>
                  <select class="form-control" [(ngModel)]="selectedSupplements">
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </select>
                  <div *ngIf="selectedSupplements=='Yes'">
                    <div class="d-flex flex-row justify-content-between" style="width:100%;margin-bottom: 10px;margin-top:10px;" *ngFor="let input of supplements;let i = index;trackBy: trackByFnSupplements">
                      <input type="text" [(ngModel)]="supplements[i]" style="width: 90%;" class="form-control" placeholder="Enter supplements" (ngModelChange)="logSupplements()">

                      <button (click)="removeSupplement(i)" class="btn btn-danger">Remove</button>
                    </div>
                    <button (click)="addSupplements()" class="btn btn-success">Add</button>
                  </div>
                </div>

                <div class="form-group col-md-6 ">
                  <div class="flex-auto mt-3">
                    <button type="submit" (click)="saveHealthAndMedicationAnswers()" class="btn btn-primary">Save</button> <span></span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="container-fluid" *ngIf="subTab=='Life'">
  <div class="card">
    <div>
      <div class="row">
        <div class="col-lg-12">
          <div class="iq-card">
            <div class="iq-card-body">
              <div class="form-group">

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of DietaryMealsTable">
                  <!--<label for="city">{{item.question}}</label>-->
                  <!--<div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Meal</th>
                          <th scope="col">Time</th>
                          <th scope="col">Information</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>breakfast</td>
                          <td>08:00 AM</td>
                          <td>4 glass water, soacked almonds</td>
                        </tr>
                      </tbody>

                    </table>
                  </div>-->
                </div>
                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of DietaryTab">
                  <label for="city">{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <input type="text" id={{item.id}} (change)="getDietary(item.id,$event,null)" [value]="item.answer" class="form-control" placeholder="Enter your answer">
                  </div>
                </div>

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let question of DietaryRadioQuestion">

                  <label for="city">{{question.question}}</label>

                  <div class="d-flex flex-row justify-content-around" style="width:30%">
                    <span class="d-flex align-items-end">Never</span>
                    <div class="d-flex flex-column options_Styles" *ngFor="let option of question.options" (click)="getDietary(option,question.id,'radio')">
                      <p class="ml-2">{{option}}</p>
                      <input type="radio" name="{{question.id}}" id="{{option}}" [checked]="!isSelectedDietaryAnswerBool ? option == question.answer : null || isSelectedDietary(question.id, option)" />
                    </div>

                    <span class="d-flex align-items-end">Very Often</span>

                  </div>
                </div>

                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of DietaryDropDownQuestions">
                  <label for="city">{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <select class="form-control" (change)="getDietary(item.id,$event,'')" [(ngModel)]="item.answer">
                      <option>select from option</option>
                      <option *ngFor="let option of item.options" [value]="option">{{option}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-6 ">
                  <div class="flex-auto mt-3">
                    <button type="submit" (click)="saveDietaryQuestions()" class="btn btn-primary">Save</button> <span></span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="subTab=='Fitness'">
  <div class="card">
    <div>
      <div class="row">
        <div class="col-lg-12">
          <div class="iq-card">
            <div class="iq-card-body">
              <div class="form-group">
                <div class="form-group col-md-12 p-3" style="background:#f4f4f4;border-radius: 15px;" *ngFor="let item of FitnessTab">
                  <label for="city">{{item.question}}</label>
                  <div class="d-flex flex-row justify-flex-start" style="width:100%;">
                    <input type="text" id={{item.id}} (change)="getFitness(item.id,$event)" [value]="item.answer"    class="form-control" placeholder="Enter your answer">
                  </div>
                  <div *ngIf="isFitnessAnswered == true ? item.answer==null : ''" style="margin-top:10px;">
                    <input type="checkbox" (click)="getFitness(item.id,$event)" /> <span style="color:red;margin-left:10px;">Not Answered!</span>
                  </div>
                </div>

                <div class="form-group col-md-6 ">
                  <div class="flex-auto mt-3">
                    <button (click)="saveFitnessQuestions()" type="submit" class="btn btn-primary">Save</button> <span></span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="container-fluid" *ngIf="subTab === 'NeoTranscript'">
  <div class="card">
    <div class="row">
      <div class="col-lg-12">

        <div *ngIf="neoTranscriptLoading" class="text-muted p-3">Loading transcripts…</div>
        <div *ngIf="neoTranscriptError" class="text-danger p-3">{{ neoTranscriptError }}</div>
        <div *ngIf="!neoTranscriptLoading && !neoTranscriptError && !memberTranscript" class="text-muted p-3">
          No transcript details found for this member.
        </div>

        <div *ngIf="memberTranscript && memberTranscriptEnabled" class="rt-wrap">

          <!-- Header -->
          <div class="rt-header">
            <div>
              <p class="rt-title">
                Renne &middot; Onboarding Transcript
                <span *ngIf="memberTranscript.isArchived"
                      style="display:inline-flex; align-items:center; gap:4px; font-size:13px; font-weight:600; color:#0a8c84; background:#e1f5ee; padding:2px 10px; border-radius:50px; vertical-align:middle; margin-left:8px;">
                  &#10003; Archived
                </span>
              </p>
              <p class="rt-subtitle">Conversation transcripts from Renne will appear here when available.</p>
            </div>
            <div class="rt-actions">
              <span *ngIf="statusUpdateLoading" class="rt-subtitle">Deleting...</span>
              <span *ngIf="archiveLoading" class="rt-subtitle">{{ memberTranscript.isArchived ? 'Unarchiving...' : 'Archiving...' }}</span>
              <button class="rt-btn rt-btn-ghost"
                      [disabled]="archiveLoading"
                      (click)="memberTranscript.isArchived ? unarchiveMemberTranscript() : archiveMemberTranscript()">
                {{ memberTranscript.isArchived ? 'Unarchive' : 'Archive' }}
              </button>
              <button class="rt-btn rt-btn-danger"
                      [disabled]="statusUpdateLoading || memberTranscript.isArchived"
                      (click)="showDeleteConfirm = true">
                Delete
              </button>
            </div>
          </div>

          <!-- Filter chips -->
          <!-- <div class="rt-filters">
            <button class="rt-chip"
                    [class.rt-chip-active]="transcriptFilter === 'all'"
                    [class.rt-chip-off]="transcriptFilter !== 'all'"
                    (click)="transcriptFilter = 'all'">
              All ({{ memberTranscript.neoConversations?.length || 0 }})
            </button>
            <button class="rt-chip"
                    [class.rt-chip-active]="transcriptFilter === 'complete'"
                    [class.rt-chip-off]="transcriptFilter !== 'complete'"
                    (click)="transcriptFilter = 'complete'">
              Complete ({{ completeCount }})
            </button>
            <button class="rt-chip"
                    [class.rt-chip-active]="transcriptFilter === 'incomplete'"
                    [class.rt-chip-off]="transcriptFilter !== 'incomplete'"
                    (click)="transcriptFilter = 'incomplete'">
              Incomplete ({{ incompleteCount }})
            </button>
          </div> -->

          <!-- Conversation cards -->
          <div class="rt-list" *ngIf="filteredConversations.length; else noTranscript">
            <div *ngFor="let item of filteredConversations"
                 class="rt-card"
                 [class.rt-card-selected]="expandedConversations.has(item.originalIndex)">

              <!-- Card header (clickable to expand/collapse) -->
              <button class="rt-card-header"
                      (click)="toggleConversationExpand(item.originalIndex)">
                <div class="rt-card-icon"
                     [class.rt-icon-complete]="item.conv.onboardingStatus?.toLowerCase() === 'complete'"
                     [class.rt-icon-incomplete]="item.conv.onboardingStatus?.toLowerCase() !== 'complete'">
                  {{ item.conv.onboardingStatus?.toLowerCase() === 'complete' ? '&#10003;' : '&#128172;' }}
                </div>
                <div class="rt-card-meta">
                  <div class="rt-card-title">
                    Session {{ item.originalIndex + 1 }}
                    <span class="rt-badge"
                          [class.rt-badge-complete]="item.conv.onboardingStatus?.toLowerCase() === 'complete'"
                          [class.rt-badge-incomplete]="item.conv.onboardingStatus?.toLowerCase() !== 'complete'">
                      {{ item.conv.onboardingStatus || 'Incomplete' }}
                    </span>
                  </div>
                  <div class="rt-card-time">
                    {{ formatConversationTimestamp(item.conv.timestamp) }}
                    <ng-container *ngIf="item.conv.transcript?.length">
                      &middot; {{ item.conv.transcript.length }} {{ item.conv.transcript.length === 1 ? 'exchange' : 'exchanges' }}
                    </ng-container>
                  </div>
                </div>
                <span class="rt-card-chevron">
                  {{ expandedConversations.has(item.originalIndex) ? '&#8963;' : '&#8964;' }}
                </span>
              </button>

              <!-- AI summary -->
              <div *ngIf="item.conv.conversationSummary" class="rt-summary">
                <div class="rt-summary-label">AI Summary</div>
                <p class="rt-summary-text">{{ item.conv.conversationSummary }}</p>
              </div>

              <!-- Chat thread -->
              <div *ngIf="item.conv.transcript?.length" class="rt-thread">
                <ng-container *ngFor="let entry of item.conv.transcript; let j = index">
                  <div *ngIf="expandedConversations.has(item.originalIndex) || j < 3"
                       class="rt-msg"
                       [class.rt-msg-agent]="entry.role === 'agent'"
                       [class.rt-msg-user]="entry.role !== 'agent'">
                    <div class="rt-avatar"
                         [class.rt-avatar-agent]="entry.role === 'agent'"
                         [class.rt-avatar-user]="entry.role !== 'agent'">
                      {{ entry.role === 'agent' ? 'R' : 'M' }}
                    </div>
                    <div class="rt-bubble"
                         [class.rt-bubble-agent]="entry.role === 'agent'"
                         [class.rt-bubble-user]="entry.role !== 'agent'">
                      {{ entry.message }}
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Expand / collapse footer -->
              <div *ngIf="item.conv.transcript?.length > 3" class="rt-card-footer">
                <button class="rt-link-btn" (click)="toggleConversationExpand(item.originalIndex)">
                  {{ expandedConversations.has(item.originalIndex) ? 'Show less &#8593;' : 'View full transcript &#8594;' }}
                </button>
              </div>
            </div>
          </div>

          <ng-template #noTranscript>
            <div class="rt-empty">No transcript available.</div>
          </ng-template>
        </div>

        <!-- Delete confirmation modal (NeoTranscript) -->
        <div *ngIf="showDeleteConfirm"
             style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:1050;display:flex;align-items:center;justify-content:center;">
          <div style="background:#fff;border-radius:8px;padding:24px;width:360px;box-shadow:0 4px 20px rgba(0,0,0,0.2);position:relative;">
            <button (click)="showDeleteConfirm = false"
                    style="position:absolute;top:10px;right:14px;background:none;border:none;font-size:18px;cursor:pointer;">&#x2715;</button>
            <h5 style="margin-bottom:12px;">Confirm Delete</h5>
            <p style="margin-bottom:20px;color:#555;">Are you sure you want to delete this transcript? <span style="color:#c94040;font-weight:600;">This action cannot be undone.</span></p>
            <div style="display:flex;gap:10px;justify-content:flex-end;">
              <button class="btn btn-secondary" (click)="showDeleteConfirm = false">No</button>
              <button class="btn btn-danger" (click)="showDeleteConfirm = false; onTranscriptStatusToggle(false)">Yes, Delete</button>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>

<!-- ── New Onboarding Tab ─────────────────────────────────────────── -->
<div class="container-fluid" *ngIf="subTab === 'NewOnboarding'">
  <div class="ob-wrap">


    <!-- Filter row: pills left, category dropdown right -->
    <div class="ob-filter-row">
      <div class="ob-filter-pills-group">
        <span class="ob-filter-pill" [ngClass]="{'ob-filter-pill-active': onboardingFilter === 'all'}" (click)="onboardingFilter = 'all'">All</span>
        <span class="ob-filter-pill" [ngClass]="{'ob-filter-pill-active': onboardingFilter === 'answered'}" (click)="onboardingFilter = 'answered'">Answered</span>
        <span class="ob-filter-pill" [ngClass]="{'ob-filter-pill-active': onboardingFilter === 'unanswered'}" (click)="onboardingFilter = 'unanswered'">Unanswered</span>
      </div>
      <select class="ob-category-select" [(ngModel)]="onboardingCategory">
        <option value="wish">Wish Questions</option>
        <option value="safety">Safety Questions</option>
        <option value="clinical">Clinical Questions</option>
        <option value="documents">Documents Questions</option>
      </select>
    </div>

    <!-- Loading spinner -->
    <div class="ob-state-row" *ngIf="onboardingLoading">
      <div class="ob-spinner"></div>
      <span>Loading answers…</span>
    </div>

    <!-- Error banner -->
    <div class="ob-error-row" *ngIf="onboardingError && !onboardingLoading">
      {{ onboardingError }}
    </div>

    <ng-container *ngIf="!onboardingLoading">

      <!-- Empty state when filter yields no results -->
      <div class="ob-empty-state" *ngIf="onboardingFilter !== 'all' && displayedOnboardingGroups.length === 0">
        <span *ngIf="onboardingFilter === 'answered'">No answered questions yet.</span>
        <span *ngIf="onboardingFilter === 'unanswered'">All questions have been answered.</span>
      </div>

      <ng-container *ngFor="let group of displayedOnboardingGroups; trackBy: trackByGroupType">
        <div class="ob-section">

          <!-- Section header -->
          <div class="ob-section-header">
            <span class="ob-section-badge" [ngClass]="'ob-badge-' + group.type">{{ group.label }}</span>
            <span class="ob-section-count">{{ group.questions.length }} questions</span>
          </div>

          <!-- Non-paid freeze notice -->
          <div class="ob-frozen-banner" *ngIf="isCategoryFrozen(group.type)">
            This member is Non - Paid. You cannot update the answers of these questions.
          </div>

          <!-- Questions -->
          <div class="ob-q-list">
            <div class="ob-q-card" *ngFor="let q of group.questions; trackBy: trackByQuestionId">

              <!-- Question top row -->
              <div class="ob-q-top">
                <span class="ob-q-num">Q{{ q._displayIndex }}</span>
                <span class="ob-q-type" [ngClass]="'ob-type-' + q.questionType">{{ q.questionType }}</span>
              </div>

              <!-- Question text -->
              <p class="ob-q-text">{{ q.question }}</p>

              <!-- Options as pills -->
              <div class="ob-q-options">
                <span class="ob-option-pill"
                      [ngClass]="{'ob-option-pill-selected': isOnboardingSelected(q.questionId, opt), 'ob-option-pill-frozen': isCategoryFrozen(group.type)}"
                      (click)="toggleOption(q.questionId, opt)"
                      *ngFor="let opt of q.questionOptions; trackBy: trackByOption">
                  {{ getOptionLabel(opt) }}
                </span>
              </div>

              <!-- Free text for trigger options -->
              <div class="ob-free-text-wrap" *ngIf="shouldShowFreeText(q.questionId)">
                <textarea class="ob-free-text-input"
                          [ngClass]="{'ob-free-text-input-lg': q.questionId === '39'}"
                          [(ngModel)]="onboardingFreeTextValues[q.questionId]"
                          placeholder="Please describe…"
                          [rows]="q.questionId === '39' ? 10 : 2"></textarea>
              </div>

            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Update footer -->
    <div class="ob-update-footer" *ngIf="!onboardingLoading">
      <div class="ob-update-success" *ngIf="onboardingUpdateSuccess">Answers saved successfully.</div>
      <div class="ob-update-error" *ngIf="onboardingUpdateError && !onboardingUpdateLoading">{{ onboardingUpdateError }}</div>
      <button class="ob-update-btn" (click)="updateOnboardingAnswers()" [disabled]="onboardingUpdateLoading || !getEditedQuestions().length || isCategoryFrozen(onboardingCategory)">
        <span *ngIf="onboardingUpdateLoading">Saving…</span>
        <span *ngIf="!onboardingUpdateLoading">Update</span>
      </button>
    </div>

  </div>
</div>
